(function() {
    angular.module('GorillaBoy.services')
    .factory('SearchService', ['$routeParams', '$http', '$log', 'SessionManager', 'EndpointService', 'AppConstants',
        function($routeParams, $http, $log, SessionManager, EndpointService, AppConstants) {

        // AppConstant bindings
        var httpMethods = AppConstants.HttpMethods;

        var searchService = {};

        searchService.searchDocuments = function (params) {
            var config = {
                url: EndpointService.endpoint() + 'search/',
                method: httpMethods.GET,
                params: params
            };

            if (config.params) {
                config.params.exclude = ['OLD_PERMISSIONS'];
            }
            
            return $http(EndpointService.tokenize(config));
        };

        return searchService;
    }]);
}());
